module.exports = __webpack_public_path__ + "img/carehome-1.0e0e24a1.jpg";